import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["disabled", "data-testid"]

import {computed} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";

interface Props {
  testId?: string;
  icon?: IconName;
  title?: string;
  primary?: boolean;
  primaryOutline?: boolean;
  outline?: boolean;
  square?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  cursorWait?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    testId: {},
    icon: {},
    title: {},
    primary: { type: Boolean },
    primaryOutline: { type: Boolean },
    outline: { type: Boolean },
    square: { type: Boolean },
    fullWidth: { type: Boolean },
    disabled: { type: Boolean },
    cursorWait: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

function click(event: Event): void {
  if (!props.disabled) {
    emit('click', event);
  }
}

const variantClass = computed(() => {
  if (props.primary) {
    if (props.disabled) {
      return 'text-neutral2-400 bg-neutral2-200';
    }
    return 'bg-primary text-on-primary border border-transparent';
  }
  if (props.primaryOutline) {
    return 'text-primary border border-primary hover:bg-green2-100';
  }
  if (props.outline) {
    return 'text-neutral2-800 border border-neutral2-200';
  }
  return 'bg-tile';
});

const cursorClass = computed(() => {
  if (props.disabled) {
    return 'cursor-not-allowed';
  }
  if (props.cursorWait) {
    return 'cursor-progress';
  }
  return 'cursor-pointer';
});

const sizeClass = computed(() => {
  if (props.square) {
    return 'size-8.5';
  }
  return 'px-4 py-2';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: click,
    class: _normalizeClass(["rounded-lg whitespace-nowrap", [variantClass.value, sizeClass.value, cursorClass.value, {'w-full': props.fullWidth}]]),
    disabled: props.disabled,
    "data-testid": props.testId
  }, [
    (props.icon)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: props.icon,
          class: _normalizeClass({'mr-2': !props.square})
        }, null, 8 /* PROPS */, ["name", "class"]))
      : _createCommentVNode("v-if", true),
    (props.title)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(props.title), 1 /* TEXT */)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})